module.exports = __webpack_public_path__ + "img/CG_first.908ca3cb.jpg";